﻿import { initLoadingStateButtons } from "../helpers";
export function initDeclarationSummary() {
    initLoadingStateButtons();
    const dialogBtn = document.querySelector("[data-terms-dialog]")
    if (dialogBtn) {
        dialogBtn.addEventListener('click', openTermsDialog);
    }
}

function openTermsDialog(event) {
    event.preventDefault();
    window.dialog.open({ elemId: event.currentTarget.dataset.termsDialog, title: event.currentTarget.dataset.termsDialogTitle});
}